import { jsx as _jsx } from "react/jsx-runtime";
export const Description = ({ children }) => (_jsx("div", { className: 'flex justify-between', children: _jsx("p", { className: 'order-none max-w-full flex-none grow-0 text-xs font-medium text-text-secondary m-0 mb-2', children: children }) }));
